
import { COLUMNS, ROWS, HEIGHT, WIDTH, getRandomCoords, createGrid, forEachRow, forEachColumn, getIndex, setCell, drawRect } from '../utils';

function initCanvas() {
  const canvas = document.createElement('canvas');
  canvas.setAttribute('width', COLUMNS)
  canvas.setAttribute('height', ROWS)
  // document.body.appendChild(canvas);
  return canvas.getContext('2d');
}

export class RippleMode {
  constructor({ addInteractionListener, addBeatListener, muted }) {
  
    this.state = {
      ripples: []
    };

    if (!muted) {
      this.audioEl = document.querySelector('audio.tick');
    }

    addInteractionListener(this.spawnRipple.bind(this));
    // addBeatListener(({major}) => {
    //   if (major && Math.random() < 0.1) {
    //     this.spawnRipple({x: 8, y: 8})
    //   }
    // });

  }

  spawnRipple(coords) {
    const existingRippleAtCoords = this.state.ripples.find(r => r.x === coords.x && r.y === coords.y);
    if (existingRippleAtCoords && existingRippleAtCoords.time < 100) {
      return;
    }
    this.state.ripples.push({
      ... coords,
      time: 2
    });
    if (this.audioEl) {
      this.audioEl.currentTime = 0;
      this.audioEl.play();
    }
  }

  update(delta) {

    const state = this.state;
    const rippleSpeed = 1/200;
    const rippleSize = 100;
    
    state.ripples.forEach((ripple, i) => {
      ripple.time += rippleSpeed * (ripple.time + 5) * delta;
      ripple.size = Math.floor(ripple.time / 2);
      if (ripple.size > rippleSize) {
        state.ripples = state.ripples.filter((r, j) => i !== j)
      }
    });

  }

  getData() {

    const data = createGrid();
    const set = (x, y) => {
      setCell(data, x, y, !data[getIndex(x, y)], {dropOutside: true});
    };
    this.state.ripples.forEach(({x, y, size, time}) => {
      if (size === 1) {
        set(x, y);
      } else if (size === 2) {
        set(x-1, y  );
        set(x+1, y  );
        set(x  , y-1);
        set(x  , y+1);
      } else if (size === 3) {
        set(x-2, y-1);
        set(x-2, y  );
        set(x-2, y+1);
        set(x+2, y+1);
        set(x+2, y  );
        set(x+2, y-1);
        
        set(x-1, y-2);
        set(x  , y-2);
        set(x+1, y-2);
        set(x-1, y+2);
        set(x  , y+2);
        set(x+1, y+2);
      } else if (size === 4) {
        set(x-2, y-2);
        set(x-3, y-1);
        set(x-3, y  );
        set(x-3, y+1);
        set(x-2, y+2);
        set(x+2, y+2);
        set(x+3, y+1);
        set(x+3, y  );
        set(x+3, y-1);
        set(x+2, y-2);
        
        set(x-1, y-3);
        set(x  , y-3);
        set(x+1, y-3);
        set(x-1, y+3);
        set(x  , y+3);
        set(x+1, y+3);
      }
    });

    return data;

  }
}
